export const LogoMark = ({ size = 38 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" data-testid="logo-mark" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0B132B" stroke="rgba(255,255,255,0.12)" />
    <g stroke="url(#lg)" strokeWidth="2.4" fill="none" strokeLinecap="round">
      <path d="M32 32 L17 19 M32 32 L47 17 M32 32 L49 44 M32 32 L15 46" />
    </g>
    <circle cx="32" cy="32" r="7" fill="url(#lg)" />
    <circle cx="17" cy="19" r="3.4" fill="#06B6D4" />
    <circle cx="47" cy="17" r="3.4" fill="#3B82F6" />
    <circle cx="49" cy="44" r="3.4" fill="#8B5CF6" />
    <circle cx="15" cy="46" r="3.4" fill="#06B6D4" />
    <defs>
      <linearGradient id="lg" x1="0" y1="0" x2="64" y2="64">
        <stop offset="0" stopColor="#3B82F6" />
        <stop offset="1" stopColor="#8B5CF6" />
      </linearGradient>
    </defs>
  </svg>
);

export const Logo = () => (
  <a href="/" className="flex items-center gap-2.5 shrink-0" data-testid="site-logo">
    <LogoMark />
    <span className="leading-none">
      <span className="block font-display font-extrabold text-lg tracking-tight text-white">
        Ad Neurone
      </span>
      <span className="block text-[10px] font-mono2 uppercase tracking-[0.35em] text-cyan-400 mt-0.5">
        Digital
      </span>
    </span>
  </a>
);
